/** Served from `public/assets/` — replace PNGs there to rebrand. */
export const BRAND_ICON_PNG = '/assets/icon.png';
export const BRAND_LOGO_PNG = '/assets/logo.png';
